









































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import { TemplateTag, TemplateTagLink } from '@/communications/templates/models/message-template';

@Component
export default class EmailTemplateTags extends Mixins(LocaleMixin) {
    @Prop({ required: false, default: () => [] }) tags!: Array<TemplateTagLink>;
    @Prop({ default: false }) isPreviewOnly!: boolean;

    get sortedTags(): Array<TemplateTag> {
        if (!this.tags || !Array.isArray(this.tags) || this.tags.length === 0) {
            return [];
        }

        const transformedTags: Array<TemplateTag> = this.tags.map(tag => ({
            id: tag.id,
            name: tag.values?.name || '',
            isSystemLocked: tag.values?.name === 'Used in Workflows'
        }));

        const workflowTags = transformedTags.filter(tag => tag.name === 'Used in Workflows');
        const otherTags = transformedTags.filter(tag => tag.name !== 'Used in Workflows').sort((a, b) => a.name.localeCompare(b.name));
        const result = [...workflowTags, ...otherTags];

        return result;
    }
}
